<template>
	<div>
		<v-autocomplete
			:value="value"
			:rules="rules"
			@change="$emit('change', $event)"
			:items="items"
			:loading="loading"
			item-text="label"
			item-value="id"
			:search-input.sync="search"
			:readonly="readonly"
			:disabled="disabled"
			:solo="solo"
			:hide-details="hide_details"
			dense
			:menu-props="{contentClass: 'select-background-base'}"
			hide-no-data
			:class="{ dense_input: dense }"
			:clearable="clearable"
			@click:clear="$emit('change', null)"
			placeholder="Rechercher un Programme"
			:hint="hint">
			<template v-slot:label>
				<span v-if="param">
					{{ param | maestroParamLabel }}
				</span>
			</template>
			<template v-slot:append>
				<v-btn
					flat icon small
					class="ma-0"
					:disabled="disabled"
					@click="explorer_show = true">
					<v-icon>search</v-icon>
				</v-btn>
			</template>
			<template v-slot:selection="{ item }">
				<span
					class="limited-length"
					:title="`${item.id} | ${item.type_text} | ${$maestro.babel_card_label(item)}`">
					{{ $maestro.babel_card_label(item) }} | {{ item.type_text }}
				</span>
			</template>
			<template v-slot:item="{ item }">
				<v-list-tile-content
					:title="`${item.id} | ${item.type_text} | ${$maestro.babel_card_label(item)}`">
					<v-list-tile-title>{{ $maestro.babel_card_label(item) }}</v-list-tile-title>
					<v-list-tile-sub-title>{{ item.type_text }}</v-list-tile-sub-title>
				</v-list-tile-content>
			</template>
		</v-autocomplete>
		<Babel
			v-if="explorer_show"
			:multiselect="false"
			:toolbarTitle="'Rechercher un programme'"
			@close="explorer_show = false"
			@selected="onCardsSelected($event)">
			<h3 slot="header">Babel ID(s) Select for Maestro ingester</h3>
		</Babel>
	</div>
</template>

<script>
import { debounce } from 'debounce'
import Babel from '@/components/modal_babel.vue'
const RE_SUIFA_REF = /[0-9]{2}(_|-|\/|\\)[0-9]{2}(_|-|\/|\\)[A-Z, a-z, 0-9]{4}/
export default {
	props: [
		'value',
		'rules',
		'param',
		'hint',
		'readonly',
		'solo',
		'dense',
		'disabled',
		'hide_details',
		'clearable',
		'card_type'
	],
	components: { Babel },
	data () {
		return {
			items: [],
			ids: [],
			search: null,
			loading: false,
			explorer_show: false
		}
	},
	watch: {
		search (val) {
			if (val && this.ids.indexOf(val) === -1) {
				this.onSearch(val)
			}
		},
		value (val) {
			if (val && this.ids.indexOf(val) === -1) {
				this.getBabels(val)
			} else if (!val) {
				this.items = []
				this.ids = []
			}
		}
	},
	methods: {
		onCardsSelected (evt) {
			this.items = [evt[0]]
			this.ids = [evt[0].id]
			this.$emit('change', evt[0].id)
		},
		onSearch: debounce(function (search) {
			if (!search) return
			if (this.loading) return
			this.getBabels(search)
		}, 100),
		getBabels (search) {
			this.loading = true
			let firstCall = this.$EsMaestro.card_search_or_read(search, this.card_type)
			let suifaRefMode = false
			if (RE_SUIFA_REF.test(search)) {
				suifaRefMode = true
				let suifaRef = search.replace(/\\|-|_|\./g, '/').trim()
				firstCall = this.$EsMaestro.card_from_suifaref(suifaRef, this.card_type)
			}
			firstCall
				.then(results => {
					this.items = results
					this.ids = results.map(item => item.id)
					if (suifaRefMode && results[0]) this.$emit('change', results[0].id)
				})
				.catch(err => {
					console.log('getBabels', err)
					if (suifaRefMode) {
						this.$EventDialer(
							'error',
							false,
							'Warning',
							`Aucun programme trouvé pour la référence ${search}`,
							0
						)
					}
				})
				.finally(() => {
					if (this.items.length === 0 && !isNaN(parseInt(search)) && !suifaRefMode) {
						this.items = [{
							id: search,
							label: `#${search}`,
							type_text: 'introuvable'
						}]
						this.ids = [search]
					}
					this.loading = false
				})
		}
	},
	mounted () {
		if (this.value && this.ids.indexOf(this.value) === -1) {
			this.getBabels(this.value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.dense_input
	>>>.v-select__selections
		margin-left: 0 !important
		flex-wrap: nowrap
		input
			margin-left: 0 !important
		.v-chip__content
			padding: 0 0 0 4px

.limited-length
	text-wrap: nowrap
	overflow-x: clip
	text-overflow: ellipsis
	max-width: 280px

</style>



// WEBPACK FOOTER //
// src/components/field_babel_id_embedded.vue